import React from 'react';
import Div from '../Element/Div/Div';
import styles from './ColorDot.module.scss';

export const ColorDot: React.FunctionComponent<{
  color: string;
  withBorder?: boolean;
}> = ({ color, withBorder }) => {
  return (
    <Div
      style={{ backgroundColor: color }}
      borderRadius={{ size: 'rounded' }}
      className={withBorder ? [styles.dot, styles.dot_with_border] : styles.dot}
      children={null}
    />
  );
};

export default ColorDot;
